up.compiler('video', (element) => {

  element.addEventListener('play', () => {
    element.currentTime = 0
  }, { once: true })

})
